import * as React from 'react';
import * as PropTypes from 'prop-types';
import IconWrapper from './IconWrapper';

const IconMailCheck = props =>
  React.createElement(
    IconWrapper,
    props,
    <svg
      width={103}
      height={84}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="block w-full h-full fill-current"
    >
      <mask id="mail-check_svg__a" maskUnits="userSpaceOnUse" x={0} y={0} width={90} height={72}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M90 9a9 9 0 00-9-9H9C4.05 0 0 4.05 0 9l45 36L90 9zm0 9L66.96 36.45l-5.625 4.5L45 54 28.665 40.95l-5.625-4.5L0 18v45a9 9 0 009 9h72a9 9 0 009-9V18z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#mail-check_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M274.5-202.5h-459v459h459v-459zM65.62 60.19a19 19 0 005.18 18.477c7.456 7.2 19.306 7.097 26.635-.232 7.329-7.329 7.432-19.179.231-26.634a19 19 0 00-32.046 8.388z"
          fill="#BDBDBD"
        />
      </g>
      <path
        d="M72.885 76.509a16 16 0 1122.624-22.624c6.063 6.278 5.976 16.257-.195 22.429-6.172 6.171-16.151 6.258-22.43.195z"
        fill="#48BB78"
      />
      <path
        d="M78.917 64.06l3.68 3.697 6.88-6.88 2.24 2.272-9.12 9.088-5.92-5.92 2.24-2.272v.016z"
        fill="#fff"
      />
    </svg>,
  );
IconMailCheck.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};
export default IconMailCheck;
